module.exports = __webpack_public_path__ + "img/director-work-icon7.c2c50c60.png";